import { Edit, Delete } from "@mui/icons-material";

import { TableActions } from "../../../components/v3";

export const getCategoryTableColumns = (handleActions, hasEditCategory, hasDeleteCategory) => {
  const headers = [
    { field: "sl", headerName: "Sl No", flex: 0.5, sortable: false },
    {
      field: "name",
      headerName: "Category Name",
      flex: 2,
      sortable: true,
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      sortable: true,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      sortable: true,
    },
  ];
  if (hasEditCategory || hasDeleteCategory) {
    headers.push({
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const actions = [];
        if (hasEditCategory) {
          actions.push({
            icon: Edit,
            type: "edit",
            label: "Edit",
            onClick: handleActions,
          });
        }
        if (hasDeleteCategory) {
          actions.push({
            icon: Delete,
            type: "delete",
            label: "Delete",
            onClick: handleActions,
          });
        }
        return <TableActions item={params} actions={actions} />;
      },
    });
  }
  return headers;
};
